module.exports = __webpack_public_path__ + "img/be81732.jpg";